import React, { useEffect } from 'react';
import { Table } from 'reactstrap';
import moment from 'moment';
import { flightInformation } from './constants';
import { useFlightBooking } from '../context/FlightBookingContext';
import './FlightInformation.scss';

function FlightInformation({ data }) {
  const { setFlightInfo } = useFlightBooking();
  useEffect(() => {
    setFlightInfo(data);
  }, [setFlightInfo, data]);

  const renderFlightInformationBody = () => {
    if (!data || data?.length === 0) {
      return (
        <tr>
          <td colSpan="7" className="text-center">
            No flight information available.
          </td>
        </tr>
      );
    }
    // Assuming flightInformation is an array of objects with properties matching the headers
    return data?.map((flight, index) => (
      <tr key={index}>
        <td>{flight?.TravelFrom_Description}</td>
        <td>{flight?.TravelToCountry_Description}</td>
        <td>{flight?.TravelTo_Description}</td>
        <td>{moment(flight?.TravelDate).format('L')}</td>
        <td>
          {flight?.TravelTime
            ? moment(flight?.TravelTime, 'HH:mm:ss').format('hh:mm A')
            : '-'}
        </td>
        <td>{flight?.Airline_Description}</td>
        <td>{flight?.TravelClass}</td>
        <td>
          {flight?.TravelClient.trim() === '' ? '-' : flight?.TravelClient}
        </td>
      </tr>
    ));
  };
  return (
    <div className="d-flex flex-column gap-2">
      <div>
        <span className="fw-semibold">Flight Information</span>
      </div>
      <div className="table-responsive">
        <Table className="ba-table" id="ba-flight-information-table">
          <thead>
            <tr>
              {flightInformation.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>{renderFlightInformationBody()}</tbody>
        </Table>
      </div>
    </div>
  );
}

export default FlightInformation;
